angular.module('user')
    .component('userList', {
        bindings: {
            items: '<',
            filterOptions: '<'
        },
        template: `
            <div class="document_user_column" ng-repeat="e in $ctrl.items | orderBy: 'fullName' track by e.id">
                <user-avatar user="e" size="20" font-size="11" filter-options="$ctrl.filterOptions"></user-avatar>&nbsp;
                <a href class="bold" >{{e.fullName}}</a>
            </div>
        `,
        controller: function () {
            this.$onInit = () => {
                if(this.items instanceof Array)
                    this.items = this.items.filter(n => n)
            }
        }
    })
